import Theme from "../../Theme"

const HealthBadge = ({status}:{status:number}) => {
    let color = "bg-ui-report-low-severity"
    if (status === 2) { 
        color = "bg-ui-report-medium-severity"
    } else if ( status === 3) {
        color = "bg-ui-report-high-severity"
    }

    return (
        <div className="">
            <div className={`${color} rounded-full w-[10px] h-[10px]`} />
        </div>
    )
}

export default HealthBadge